import React from "react";

const Ideas = () => {
  return <div>Ideas</div>;
};

export default Ideas;
